import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MenuButton = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const BackgroundBlock = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: ${props => (props.open ? '0px' : '-100%')};
  opacity: ${props => (props.open ? 1 : 0)};
  will-change: opacity;
  transform: translateZ(0px);
  transition:
    left 0ms cubic-bezier(0.23, 1, 0.32, 1) ${props => (props.open ? 0 : 400)}ms,
    opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  background-color: rgba(32, 31, 44, 0.8);
  pointer-events: ${props => (props.open ? 'auto' : 'none')};
  z-index: 1200;
`;
export const MenuWrapper = styled.div`
  position: fixed;
  width: 304px;
  height: 100%;
  box-sizing: border-box;
  box-shadow:
    rgba(0, 0, 0, 0.16) 0px 3px 10px,
    rgba(0, 0, 0, 0.23) 0px 3px 10px;
  border-radius: 0px;
  top: 0px;
  left: 0px;
  transform: translate(${props => (props.open ? 0 : -314)}px, 0px);
  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  overflow: auto;
  color: rgba(0, 0, 0, 0.87);
  background-color: ${ColorSF2.paleBlue};
  z-index: 1300;
`;
export const MenuItem = styled.div`
  position: relative;
  margin: 0px;
  padding: ${props => `0px 16px 0px ${(props.indent && '32px') || '16px'}`};
  min-height: 48px;
  line-height: 48px;
  display: block;
  border: 10px;
  box-sizing: border-box;
  cursor: ${props => (props.default && 'default') || 'pointer'};
  outline: none;
  font-size: 16px;
  text-decoration: none;
  white-space: nowrap;
  background: none;
  color: ${ColorSF2.black};
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-height: 376px) {
    font-size: 12px;
    min-height: 36px;
    line-height: 36px;
  }
`;
export const MenuItemCloseButton = styled(MenuItem)`
  height: 50px;
`;
export const PolicyLinks = styled.div`
  position: absolute;
  bottom: 40px;
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: auto;
  ${props =>
    props.overflow &&
    `
    position: relative;
    margin-top: 30px;
    bottom: 0px;
  `}
`;

export const PolicyLink = styled.a`
  color: ${ColorSF2.black};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const Version = styled.div`
  position: absolute;
  bottom: 0px;
  padding: 10px;
  color: #43528a;
  font-size: 10px;
  line-height: 14px;
  ${props =>
    props.overflow &&
    `
    position: relative;
    margin-top: 0px;
  `}
`;
export const CloseButton = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
`;
export const CloseButtonImage = styled.img`
  width: 15px;
  height: 15px;
`;
